import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import TemplateCenter from './views/TemplateCenter.vue'
import ModelManage from './views/ModelManage.vue'
import PluginManage from './views/PluginManage.vue'
import DialogueManage from './views/DialogueManage.vue'
import ChannelAccess from './views/ChannelAccess.vue'
import ClientManage from './views/ClientManage.vue'
import Workflow from './views/Workflow.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/template',
      name: 'template',
      component: TemplateCenter,
      meta: { requiresAuth: true }
    },
    {
      path: '/model',
      name: 'model',
      component: ModelManage,
      meta: { requiresAuth: true }
    },
    {
      path: '/plugin',
      name: 'plugin',
      component: PluginManage,
      meta: { requiresAuth: true }
    },
    {
      path: '/dialogue',
      name: 'dialogue',
      component: DialogueManage,
      meta: { requiresAuth: true }
    },
    {
      path: '/channel',
      name: 'channel',
      component: ChannelAccess,
      meta: { requiresAuth: true }
    },
    {
      path: '/client',
      name: 'client',
      component: ClientManage,
      meta: { requiresAuth: true }
    },
    {
      path: '/workflow',
      name: 'workflow',
      component: Workflow,
      meta: { requiresAuth: true }
    }
  ]
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'

  // 如果路由需要登录认证且用户未登录
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    // 重定向到首页而不是登录页
    next({ path: '/' })
  } else {
    next()
  }
})

export default router 